<a role="button" tabindex="0" href="#" (click)="skipToContent($event)" class="skip-to-content">Skip to Content</a>

<prep-loading-indicator></prep-loading-indicator>
<prep-backdrop #backdrop="prepBackdrop"></prep-backdrop>

<div class="container" fxLayout="column">
  <ng-container *ngIf="(toolbarPosition$ | async) === 'above-fixed'">
    <ng-container *ngTemplateOutlet="toolbar"></ng-container>
  </ng-container>

  <mat-sidenav-container autosize fxFlex>

    <!-- SIDENAV -->
    <mat-sidenav (closedStart)="closeSidenav()" (openedStart)="openSidenav()" [mode]="sidenavMode$ | async"
      [opened]="sidenavOpen$ | async" *ngIf="sideNavigation$ | async" class="prep-collapsable-sidenav">
      <prep-sidenav [collapsed]="sidenavCollapsed$ | async" [expanded]="sidenavExpanded$ | async"></prep-sidenav>
    </mat-sidenav>
    <!-- END SIDENAV -->

    <mat-sidenav-content class="content-container" fxLayout="column">
      <ng-container *ngIf="(toolbarPosition$ | async) === 'fixed'">
        <ng-container *ngTemplateOutlet="toolbar"></ng-container>
      </ng-container>

      <main role="main" id="main-content" tabindex="-1" [class.scroll-disabled]="scrollDisabled$ | async" cdkScrollable
        class="content" fxFlex="auto" fxLayout="column">
        <prep-loading-indicator></prep-loading-indicator>
        <ng-container *ngIf="(toolbarPosition$ | async) === 'static'">
          <ng-container *ngTemplateOutlet="toolbar"></ng-container>
        </ng-container>

        <div class="content-inner" fxFlex="auto">
          <router-outlet></router-outlet>
        </div>

        <ng-container *ngIf="(footerPosition$ | async) === 'static'">
          <ng-container *ngTemplateOutlet="footer"></ng-container>
        </ng-container>
      </main>

      <ng-container *ngIf="(footerPosition$ | async) === 'fixed'">
        <ng-container *ngTemplateOutlet="footer"></ng-container>
      </ng-container>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <ng-container *ngIf="(footerPosition$ | async) === 'above-fixed'">
    <ng-container *ngTemplateOutlet="footer"></ng-container>
  </ng-container>
</div>

<ng-template #toolbar>
  <!-- TOOLBAR -->
  <prep-toolbar (openQuickPanel)="openQuickPanel()" [hasNavigation]="topNavigation$ | async"
    (openSidenav)="openSidenav()" *ngIf="toolbarVisible$ | async" fxFlex="none"></prep-toolbar>
  <!-- END TOOLBAR -->

  <!-- NAVIGATION -->
  <prep-navigation *ngIf="topNavigation$ | async" fxFlex="none"></prep-navigation>
  <!-- END NAVIGATION -->
</ng-template>

<ng-template #footer>
  <!-- FOOTER -->
  <prep-footer fxFlex="none"></prep-footer>
  <!-- END FOOTER -->
</ng-template>